import { useState, useEffect } from 'react';

/**
 * Hook for subscribing to a CSS media query
 * @param {string} query - Media query string
 * @returns {boolean} - Whether the query currently matches
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => setMatches(media.matches);
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [query]);
    return matches;
}
